// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// import '@mdi/font/css/materialdesignicons.css'
import Vue from 'vue'
import 'vuetify/src/stylus/app.styl'
// import 'vuetify/dist/vuetify.css'
import Vuetify, {
  VApp, // required
  VNavigationDrawer,
  VFooter,
  VToolbar,
  VFadeTransition,
  VBtn,
  VFlex,
  VLayout,
  VList,
  VListTile,
  VListTileContent,
  VListTileAction,
  VListTileAvatar,
  VListTileTitle,
  VIcon,
  VDivider,
  VToolbarSideIcon,
  VToolbarTitle,
  VDataTable,
  VPagination,
  VBreadcrumbs,
  VExpansionPanel,
  VExpansionPanelContent,
  VCard,
  VCardText,
  VTab,
  VTabs,
  VSnackbar,
  VProgressCircular,
  VDialog,
  VCardTitle,
  VCardActions,
  VSpacer,
  VTooltip,
  VContainer,
  VTextField
} from 'vuetify/lib'

import router from '@/router'
import store from '@/store'
import { sync } from 'vuex-router-sync'
import Main from './components/Main.vue'
import VueLodash from 'vue-lodash'
import lodash from 'lodash'
Vue.config.productionTip = false
sync(store, router)
const options = { name: 'vueLodash', lodash: lodash }
Vue.use(VueLodash, options)

Vue.use(Vuetify, {
  icons: {
    iconfont: 'mdi' // default - only for display purposes
  },
  theme: {
    // primary: '#2c3e50',
    // secondary: '#1abc9c',
    // accent: '#2980b9',
    // error: '#e74c3c',
    // action: '#23DB2A'
  },
  components: {
    VApp,
    VNavigationDrawer,
    VFooter,
    VToolbar,
    VFadeTransition,
    VBtn,
    VLayout,
    VFlex,
    VList,
    VListTile,
    VListTileContent,
    VListTileAction,
    VListTileAvatar,
    VListTileTitle,
    VIcon,
    VDivider,
    VToolbarSideIcon,
    VToolbarTitle,
    VDataTable,
    VPagination,
    VBreadcrumbs,
    VExpansionPanel,
    VExpansionPanelContent,
    VCard,
    VCardText,
    VTab,
    VTabs,
    VSnackbar,
    VProgressCircular,
    VDialog,
    VCardTitle,
    VCardActions,
    VSpacer,
    VTooltip,
    VContainer,
    VTextField
  }
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(Main)
})



// WEBPACK FOOTER //
// ./src/main.js